module.exports = __webpack_public_path__ + "img/Book.506fd70f.png";